/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wm_Quiz_Participation_Terms_DescriptionInputs */

const de_wm_quiz_participation_terms_description = /** @type {(inputs: Wm_Quiz_Participation_Terms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmebedingungen zum WM-Quiz von waipu.tv – Voraussetzungen, Ablauf und Gewinnchancen im Überblick.`)
};

/** @type {(inputs: Wm_Quiz_Participation_Terms_DescriptionInputs) => LocalizedString} */
const en_wm_quiz_participation_terms_description = de_wm_quiz_participation_terms_description;

/**

* @param {Wm_Quiz_Participation_Terms_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const wm_quiz_participation_terms_description = /** @type {((inputs?: Wm_Quiz_Participation_Terms_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wm_Quiz_Participation_Terms_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_wm_quiz_participation_terms_description(inputs)
	return en_wm_quiz_participation_terms_description(inputs)
});